import { render, staticRenderFns } from "./shopscategory-add-or-update.vue?vue&type=template&id=46020219&"
import script from "./shopscategory-add-or-update.vue?vue&type=script&lang=js&"
export * from "./shopscategory-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports